<button class="button button-primary button-medium" (click)="pay()" [disabled]="!hasOrderOptions()">Оплатить</button>
